import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/data/controller",

        async get() {
            return await Vue.http.get(this.url());
        },

        async update(data) {
            return await Vue.http.post(this.url(), data);
        }
    },
    base
);
